import React, { useEffect, useMemo, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import BlogHeader from '../../Organisms/BlogHeader';

import { IPostsListPageProps } from './PostsListPage.definitions';

/** CSS import */
import Styles from './PostsListPage.module.scss';
import List from './Components/Organisms/List';
import Posts from './Components/Organisms/Posts';
import { useHistory, useLocation, Redirect } from 'react-router';
import { useFetchArticles } from 'Pages/Blog/Hooks/useFetchArticles';
import { EArticleCategory } from 'Pages/Blog/Hooks/Definitions/Article.d';
import InfiniteScroll from 'Pages/Home/Components/Molecules/InfiniteScroll';
import { Col, Row } from 'antd';
import ReactLoading from 'react-loading';
import { useGetViewType } from 'Pages/Home/Hooks/useGetViewType';
import { useFetchArticleCategories } from 'Pages/Blog/Hooks/useFetchArticleCategories';

const Loader: React.FC<{ isVisible?: boolean }> = ({ isVisible }) => {
  return (
    <Row
      justify="center"
      align="middle"
      style={{ paddingBottom: 64, display: isVisible ? 'flex' : 'none' }}
    >
      <Col>
        <ReactLoading type={'spin'} height={50} width={50} color={'#4A4A4A'} />
      </Col>
    </Row>
  );
};

const PostsListPage: React.FC<IPostsListPageProps> =
  ({}: IPostsListPageProps) => {
    const history = useHistory();

    const { isDesktopView, isMobileView } = useGetViewType();
    const [title, setTitle] = useState('');
    const [sideTitle, setSideTitle] = useState('');
    const [category, setCategory] = useState<EArticleCategory>(
      EArticleCategory.All,
    );
    const [stopFetch, setStopFetch] = useState(true);

    const { data, infiniteData, isFetching, response, hasMoreData, loadMore } =
      useFetchArticles({
        category,
        stopFetch,
      });

    const {
      data: sideData,
      isFetching: isFetchingSideData,
      response: responseSideData,
    } = useFetchArticles({
      category:
        category === EArticleCategory.Popular
          ? EArticleCategory.Latest
          : EArticleCategory.Popular,
      stopFetch: stopFetch || isMobileView,
    });

    const handleTypeChange = (title: string) => {
      switch (title) {
        case 'popular': {
          setTitle('Popular');
          setSideTitle('Latest');
          setCategory(EArticleCategory.Popular);
          setStopFetch(false);
          break;
        }
        case 'latest': {
          setTitle('Latest');
          setSideTitle('Popular');
          setCategory(EArticleCategory.All);
          setStopFetch(false);
          break;
        }
        case 'fashion': {
          setTitle('Fashion');
          setSideTitle('Popular');
          setCategory(EArticleCategory.Fashion);
          setStopFetch(false);
          break;
        }
        case 'luxury': {
          setTitle('Luxury');
          setSideTitle('Popular');
          setCategory(EArticleCategory.Luxury);
          setStopFetch(false);
          break;
        }
        case 'sneakers': {
          setTitle('Sneakers');
          setSideTitle('Popular');
          setCategory(EArticleCategory.Sneakers);
          setStopFetch(false);
          break;
        }
        default: {
          setTitle('');
          setSideTitle('');
          setCategory(EArticleCategory.All);
          setStopFetch(true);
          break;
        }
      }
    };

    const isReady = useMemo(() => {
      return !isFetching && !!response;
    }, [isFetching, response]);

    const isReadySideData = useMemo(() => {
      return !isFetchingSideData && !!responseSideData;
    }, [isFetchingSideData, responseSideData]);

    useEffect(() => {
      const category = history.location.pathname.split('/')[2];
      handleTypeChange(category);
    }, [history.location.pathname]);

    const handleScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
      if (!hasMoreData) {
        return;
      }

      const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

      const maxScrollY = scrollHeight - clientHeight;
      const position = Math.ceil(scrollTop);

      if (!isFetching && position >= maxScrollY * 0.95) {
        loadMore();
      }
    };

    useEffect(() => {
      const category = history.location.pathname.split('/')[2];
      let _hash = '';
      switch (category) {
        case 'popular': {
          _hash = EArticleCategory.Popular;
          break;
        }
        case 'latest': {
          _hash = 'latest';
          break;
        }
        case 'fashion': {
          _hash = EArticleCategory.Fashion;
          break;
        }
        case 'luxury': {
          _hash = EArticleCategory.Luxury;
          break;
        }
        default: {
          break;
        }
      }

      _hash &&
        localStorage.setItem('kickavenews-back-from-post-listing', '#' + _hash);
    }, [category]);

    return (
      <div className={Styles['wrapper']}>
        <BlogHeader />
        <div className={Styles['posts-list-body']} onScroll={handleScroll}>
          <div className={Styles['main-content']}>
            <InfiniteScroll
              renderContent={
                <Posts
                  title={title}
                  items={infiniteData}
                  isReady={isReady}
                  slug={category}
                />
              }
              next={() => {}}
              hasMore={hasMoreData}
              dataLength={data.length}
              loader={<Loader isVisible={isFetching} />}
            />
          </div>
          {isDesktopView && (
            <div className={Styles['popular-content']}>
              <List
                title={sideTitle}
                items={sideData}
                isReady={isReadySideData}
              />
            </div>
          )}
        </div>
      </div>
    );
  };

export default PostsListPage;
